import utils from "../utils";
import Cookie from "js-cookie";
import constants from "../values/constants";
import errorHandler from "../utils/errorHandler";

import axios, { AxiosResponse, InternalAxiosRequestConfig } from "axios";

const customAxios = axios.create({
  baseURL: constants.BASE_URL,
  headers: {
    authorization: `Bearer ${Cookie.get(constants.USER.TOKEN)}`,
    accept: `application/json`,
    type: `${utils.stringHexConversion.reverse(
      Cookie.get(constants.USER.TYPE)
    )}`,
  },
});
const customAxiosV2 = axios.create({
  baseURL: constants.BASE_URL_v2,
  headers: {
    authorization: `Bearer ${Cookie.get(constants.USER.TOKEN)}`,
    accept: `application/json`,
    type: `${utils.stringHexConversion.reverse(
      Cookie.get(constants.USER.TYPE)
    )}`,
  },
});

customAxios.interceptors.response.use(
  function (response: AxiosResponse<any, any>) {
    return response;
  },
  // ?? ===============================================================================================================
  // ?? This function is depends on BACK-END status codes =============================================================
  function (error: any) {
    if (error?.response?.status === constants.CODE_LOGOUT_USER)
      return utils.cookiesValue.remove();
    errorHandler(
      error?.response.errorCode ?? error?.response?.data?.CODE
        ? error.response.data.CODE
        : error.response.data.statusCode
    );
    return false;
  }
);

// ?? =================================================================================================================
// ?? It's optional for "https" domains ===============================================================================
// ?? Add the following lines to set the CORS headers =================================================================
customAxios.interceptors.request.use(
  (config: InternalAxiosRequestConfig<any>) => {
    if (config.headers) {
      config.headers["Access-Control-Allow-Origin"] = "*";
      config.headers["Access-Control-Allow-Methods"] =
        "GET, POST, PUT, DELETE, OPTIONS";
      config.headers["Access-Control-Allow-Headers"] =
        "Content-Type, Authorization";
    }
    return config;
  }
);

export default customAxios;
